import { ForkCheckerApi } from './forkCheckerApi';

export const forkCheckerApi = new ForkCheckerApi()